import rest from '@exchange/libs/utils/rest/src';

interface BEDocumentDownloadResponse {
  url: string;
}

export default function DocumentResources({ base, documentURL }) {
  return {
    async download(): Promise<BEDocumentDownloadResponse> {
      const response = await rest.request(
        {
          url: `${documentURL}/download`,
          base,
        },
        {
          useSubaccount: false,
          respondWithReaders: true,
        },
      );

      return response.data;
    },
  };
}
